"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformApiResponse = exports.usePageInteractions = void 0;
var axios_1 = __importDefault(require("axios"));
var swr_1 = __importDefault(require("swr"));
var inversify_react_1 = require("inversify-react");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
function usePageInteractions(_a) {
    var pageId = _a.pageId, viewId = _a.viewId, dedupingInterval = _a.dedupingInterval;
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var url = "".concat(apiBaseUrl, "/page-interactions/pages/").concat(pageId);
    var data = (0, swr_1.default)([url, viewId], function (args) { return fetchPageInteractions.apply(void 0, __spreadArray([], __read(args), false)); }, {
        dedupingInterval: dedupingInterval,
    }).data;
    return { pageInteractions: data };
}
exports.usePageInteractions = usePageInteractions;
function fetchPageInteractions(url, viewId) {
    return __awaiter(this, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.get(url, {
                        withCredentials: true,
                        params: { viewId: viewId },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2, transformApiResponse(data)];
            }
        });
    });
}
function transformApiResponse(apiData) {
    var pageInteractions = [];
    var i = 0;
    while (i < apiData.length) {
        var collapsableResponse = transformCollapsable(i, apiData);
        if (collapsableResponse) {
            pageInteractions.push(collapsableResponse.transformed);
            i += collapsableResponse.count;
            continue;
        }
        var d = apiData[i];
        var transformed = transformInteraction(d);
        if (transformed != undefined) {
            pageInteractions.push(transformed);
        }
        ++i;
    }
    return pageInteractions;
}
exports.transformApiResponse = transformApiResponse;
var oneMinuteMs = 60 * 1000;
function transformCollapsable(startIndex, apiData) {
    var _a;
    var first = apiData[startIndex];
    if (first.interactionName !== "Block Entered Viewport")
        return undefined;
    var firstTimestamp = new Date(first.timestamp);
    var blocks = [];
    var count = 0;
    while (startIndex + count < apiData.length) {
        var d = apiData[startIndex + count];
        if (d.interactionName !== "Block Entered Viewport")
            break;
        var thisTimestamp = new Date(d.timestamp);
        if (firstTimestamp.getTime() - thisTimestamp.getTime() > oneMinuteMs) {
            break;
        }
        blocks.push({
            blockName: (_a = d.metadata.blockName) !== null && _a !== void 0 ? _a : "",
            blockType: mapBlockType(d.metadata.blockType),
        });
        ++count;
    }
    return {
        count: count,
        transformed: {
            timeStamp: firstTimestamp,
            eventData: {
                eventType: "Blocks Entered Screen",
                blocks: blocks,
            },
        },
    };
}
var blockTypeValues = Object.values(BlockTypes_1.BlockType);
function mapBlockType(blockTypeString) {
    if (!blockTypeString)
        return undefined;
    if (blockTypeValues.includes(blockTypeString)) {
        return blockTypeString;
    }
    return undefined;
}
function transformInteraction(singleInteractionResponse) {
    var timestamp = singleInteractionResponse.timestamp, eventType = singleInteractionResponse.interactionName, metadata = singleInteractionResponse.metadata;
    var timeStamp = new Date(timestamp);
    switch (eventType) {
        case "Accordion Opened":
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    title: metadata.title,
                },
            };
        case "Button Clicked":
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    buttonText: metadata.buttonText,
                },
            };
        case "Block Unfolded":
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    h1: metadata.h1,
                    h2: metadata.h2,
                },
            };
        case "Clicked Navigation Item":
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    blockName: metadata.blockName,
                },
            };
        case "Outbound Link Click":
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    linkText: metadata.linkText,
                    linkUrl: metadata.linkUrl,
                },
            };
        case "ROI Calculator Updated": {
            var term = metadata.term && metadata.termValue ? { termName: metadata.term, termValue: metadata.termValue } : undefined;
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    sliderValue: metadata.sliderValue,
                    term: term,
                },
            };
        }
        case "Page Partially Accepted":
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    acceptanceTimestamp: new Date(metadata.acceptanceTimestamp),
                    eSigned: metadata.eSigned,
                    accepter: transformAccepter(metadata.accepter),
                },
            };
        case "Page Accepted": {
            return {
                timeStamp: timeStamp,
                eventData: {
                    eventType: eventType,
                    acceptanceTimestamp: new Date(metadata.acceptanceTimestamp),
                    eSigned: metadata.eSigned,
                    accepters: metadata.accepters.map(transformAccepter),
                },
            };
        }
    }
    return undefined;
}
function transformAccepter(_a) {
    var name = _a.name, email = _a.email, acceptedAt = _a.acceptedAt, company = _a.company, signatureUrl = _a.signatureUrl;
    var acceptedAtDate = new Date(acceptedAt);
    return {
        name: name,
        email: email,
        company: company,
        signatureUrl: signatureUrl,
        acceptedAt: acceptedAtDate,
    };
}
